import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const NikeTwillHat = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[15].productName}
				color={product.allGear[15].color}
				size={product.allGear[15].sizes}
				price={product.allGear[15].price}
				img={product.allGear[15].img}
				miniImg1={product.allGear[15].miniImg1}
				miniImg2={product.allGear[15].miniImg2}
				miniImg3={product.allGear[15].miniImg3}
			/>
		</React.Fragment>
	);
};

export default NikeTwillHat;
